import React, { useRef,useContext,useEffect } from 'react';
import { ShoppingStart } from '../../components/ShoppingStart';
// import { iAeonSetData } from '../../library/iaeon_sdk.js';

import styles from '../../styles/Checkout.module.scss';

// import useSound from 'use-sound';
// import se_08 from '../../sound/s08_se_delay0.mp3';

export function RegiSelfComp(props) {

// const [se08_se] = useSound(se_08);

const ShoppingStartContext = useContext(ShoppingStart);


//----------------------------------------
//初期化
//----------------------------------------

useEffect(() => {
	document.body.classList.add('bg_white');
	document.getElementById('header').classList.remove('is_fixed');
	document.getElementById('header').classList.remove('is_behind');

	props.setRegiType("regi_self_comp");

	//高さ調整：arrows We 対応
	if(window.innerWidth >= 320){
		document.documentElement.style.zoom = window.innerWidth / 390;
		var zratio = window.innerWidth / 390;
	}else{
		document.documentElement.style.zoom = 1;
		var zratio = 1;
	}
	let hratio = window.innerHeight / (window.innerHeight * zratio);
	let realheight = window.innerHeight * hratio;
	let elementA = document.getElementById('regiFrame');
	if (elementA) {
		elementA.style.height = realheight + 'px';
	}
}, []);


useEffect(() => {
	//お買物API：画面遷移API（精算完了画面
	props.okaimonoAPI_didScreenTransition("complete_payment");
}, []);


const goKujiLottery = () => {
	props.setPage("kuji_lottery");
	// se08_se();
	props.setSoundState("se08_se");
}
const goKujiList = () => {
	props.setPage("kuji_list");
	// se08_se();
	props.setSoundState("se08_se");
}
const goRegiMeisai = () => {
	props.setPage("regi_meisai");
	// se08_se();
	props.setSoundState("se08_se");
}


return (
	<>
	<div id="regiFrame" className={styles.regiFrame}>
	<div id="checkoutBox" className={styles.checkoutBox}>

{
	(() => {
		if(ShoppingStartContext.data){
			if (ShoppingStartContext.data.bonusFlag === 1) { //ボーナス有効
				if(props.shoppingData){
					if (props.shoppingData.data) { //SUCCESS

						if(props.shoppingData.data.campaign.bonusAmount === 0){ //売上なし
							return (
								<></>
							)
						}else{ //通常表示
							return (
								<div className={styles.bonus_result}>
									<p className={styles.bonus_result_txt}>
										<span>{props.shoppingData.data.campaign.bonusAmount ? (props.shoppingData.data.campaign.bonusAmount).toLocaleString('ja-JP') : 0}</span>円引きが適用されました
									</p>
									<span className={styles.bonus_result_img}>
										<img src="/images/kuji/bonus_result.png" alt="" width="390" height="72"/>
									</span>
								</div>
							)
						}

					}else{ //売上なし
						return (
							<></>
						)
					}
				}else{ //売上なし
					return (
						<></>
					)
				}
			}
		}
	})()
}

		<p className={styles.checkoutBox_tit}>お買い上げ<br/>ありがとうございました</p>
		<div className={`${styles.checkoutBox_img} ${styles.checkoutBox_img02}`}>
			<img src="/images/img_checkout_self.svg" alt="" width="247" height="168"/>
		</div>

		<div className={`commonBtn commonBtn04 ${styles.meisaiBtn}`} onClick={goRegiMeisai}><span>送信明細を見る</span></div>

		{
			(() => {
				if(ShoppingStartContext.data.lotteryFlag === 1){ //くじ有効
					if(props.shoppingData){
						if (props.shoppingData.data) { //SUCCESS
							if(props.shoppingData.data.campaign.lotteryTimes !== 0){ //くじ回数0でない
								if (props.kujiResult.length === 0) { //くじを引く
									return(
										<div className={styles.kujiBtn} onClick={goKujiLottery}><span className={styles.kujiBtn_in}><span>
										<span className={styles.kujiBtn_in_icn}>
											<img src="/images/icn_kujibtn.svg" alt="" width="29" height="39" />
										</span>
										くじを引く</span></span></div>
									)
								} else { //くじの結果を見る
									return (
										<div className={styles.kujiBtn} onClick={goKujiList}><span className={styles.kujiBtn_in}><span className={styles.is_noicn}>くじの結果を見る</span></span></div>
									)
								}
							}

						}
					}
				}
			})()
		}
	</div>
	</div>
	</>
)

}
